import { render } from "./TransactionShippingDetail.vue?vue&type=template&id=038ebf45&scoped=true&ts=true"
import script from "./TransactionShippingDetail.vue?vue&type=script&lang=ts"
export * from "./TransactionShippingDetail.vue?vue&type=script&lang=ts"

import "./TransactionShippingDetail.vue?vue&type=style&index=0&id=038ebf45&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038ebf45"]])

export default __exports__